module.exports = __webpack_public_path__ + "img/calc.06cc282.svg";